import { useJpMode } from '@/lib/jpMode';
import { toWareki } from '@/lib/jp-format';

/**
 * Auto-renders a date as 元号 or AD depending on the user's JP-mode
 * setting. Falls back to a localized AD string when wareki is off.
 *
 * Use this anywhere a date renders in the workspace so JP users can
 * toggle once and have every date in the app follow.
 */
export function JpDate({ value }: { value: Date | string | number }) {
  const { wareki } = useJpMode();
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  if (wareki) {
    return (
      <span title={d.toLocaleDateString('en-US')}>{toWareki(d)}</span>
    );
  }
  return <span>{d.toLocaleDateString()}</span>;
}
